import { render, staticRenderFns } from "./EditPwd.vue?vue&type=template&id=2dc1c25c&"
import script from "./EditPwd.vue?vue&type=script&lang=js&"
export * from "./EditPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports